var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"open-support-widget",attrs:{"onclick":"window.fcWidget.open();"}},[_vm._v("contact support")])}
var staticRenderFns = []

export { render, staticRenderFns }